import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CalendarLoader from "../../common-components/CalendarLoader";
import {
  getCardIcon,
  getCardIconType,
  getCardTitle,
} from "../live-subs/mockSubscriptionData";

const RenewalCheckinsStat = ({ statsData, setStatsData }) => {
  const {
    renewalCheckinStat,
    renewalCheckinStatError,
    renewalCheckinStatLoading,
  } = useSelector((state) => state.live);

  useEffect(() => {
    if (
      !renewalCheckinStatLoading &&
      !renewalCheckinStatError &&
      renewalCheckinStat?.status
    ) {
      setStatsData(renewalCheckinStat?.data?.[0]);
    } else {
      setStatsData({
        total: 0,
        monthly: 0,
        quaterly: 0,
        half_yearly: 0,
        yearly: 0,
      });
    }
  }, [renewalCheckinStatLoading, renewalCheckinStatError, renewalCheckinStat]);

  return (
    <div className="live-subscriptions mr-kpi-grid grid-5 mt30">
      {renewalCheckinStatLoading ? (
        <CalendarLoader daysCount={3} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, data]) => {
          return (
            <div className="mr-kpi-card" key={key}>
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{data || 0}</div>
                  </div>
                </div>
                <span
                  className="mr-kpi-card-icon-container"
                  style={{
                    backgroundColor:
                      getCardIconType(key) === "blue"
                        ? "#dbeafe"
                        : getCardIconType(key) === "green"
                        ? "#d1fae5"
                        : getCardIconType(key) === "orange"
                        ? "#fed7aa"
                        : "#f3f4f6",
                    color:
                      getCardIconType(key) === "blue"
                        ? "#1e40af"
                        : getCardIconType(key) === "green"
                        ? "#065f46"
                        : getCardIconType(key) === "orange"
                        ? "#c2410c"
                        : "#374151",
                  }}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default RenewalCheckinsStat;
